<template lang="pug">
v-expansion-panel.thesis-panel(v-if='!!theses.length')
  person-expansion-header(:title='`${title} (${theses.length})`', :icon='icon')
  v-expansion-panel-text
    .thesis-panel-list
      article.thesis-panel-item(v-for='(t, i) in theses', :key='i')
        person-thesis-item-content(
          :thesis='t',
          :showSupervisor='showSupervisor',
          :showTutor='showTutor',
          :showStudent='showStudent',
          :descriptionOpenByDefault='descriptionOpenByDefault',
          :personContext='personContext'
        )
</template>

<script setup lang="ts">
import type { PersonInterface } from '~/interfaces/person'
import type { Thesis } from '~/models/thesis'

defineOptions({
  name: 'ThesisPanel',
})

defineProps({
  personContext: {
    type: Object as () => PersonInterface,
    required: true,
  },
  theses: {
    type: Array as () => Array<Thesis>,
    required: true,
  },
  title: {
    type: String,
    default: 'Theses',
  },
  icon: {
    type: String,
    default: 'mdi-calendar-check-outline',
  },
  showSupervisor: {
    type: Boolean,
    default: true,
  },
  showTutor: {
    type: Boolean,
    default: true,
  },
  showStudent: {
    type: Boolean,
    default: true,
  },
  descriptionOpenByDefault: {
    type: Boolean,
    default: true,
  },
})
</script>

<style scoped>
.thesis-panel {
  margin: 0 0 0.9rem;
  border: 1px solid var(--border-default);
  background: var(--surface-card);
  box-shadow: none;
  width: 100%;
  max-width: 100%;
}

.thesis-panel-list {
  display: grid;
  gap: 1.05rem;
  padding: 0.45rem 0 0.2rem;
}

.thesis-panel-item {
  display: block;
  min-width: 0;
}
</style>
